import React from "react";
import styles from "./HeadingWithLine.module.scss";

function HeadingWithLine({ text, line = true, className, margin = true }) {
  return (
    <div
      className={`${styles.heading_with_line} ${className} ${!margin && styles.noMargin}`}
    >
      {text && <h5>{text}</h5>}
      {line && <div className={styles.line}></div>}
    </div>
  );
}

export default HeadingWithLine;
